import React from "react";
import { connect } from "react-redux";

import DataGrid, {
  Column,
  LoadPanel,
  Scrolling,
  FilterRow,
  Selection
} from "devextreme-react/data-grid";
import OutsideClickHandler from "react-outside-click-handler";
import CachedIcon from "@material-ui/icons/Cached";
import { withStyles } from "@material-ui/core/styles";

import { columns } from "./utils";
import AddButton from "../../../../../ui/AddButton";
import DeleteButton from "../../../../../ui/DeleteButton";
import Box from "../../../../../ui/Box";
import AddInventTypeModal from "./components/AddInventTypeModal";
import UpdateInventTypeModal from "./components/UpdateInventTypeModal";
import DeleteConfirmationModal from "../../../../../ui/DeleteConfirmationModal";
import { deleteResourceTypes } from "../store/deleteactions";

const styles = {
  root: {
    display: "flex",
    flexDirection: "row",
    "& #gridContainer": {
      height: "calc(100vh - 200px)"
    }
  },
  controls: {
    display: "flex",
    justifyContent: "space-between",
    marginBottom: "16px",
    "& > div": {
      display: "flex",
      alignItems: "flex-end",
      "& > *:not(:nth-last-child(1))": {
        marginRight: "14px"
      }
    }
  }
};

class InventoryTypeTable extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      collapsed: false,
      selectedInventTypes: [],
      deleteConfimationOpen: false,
      addInventTypeOpen: false,
      updateInventTypeOpen: false,
      focusedInventType: -1,
      focusedInventTypeIndex: -1
    };

    this.selectInventTypes = this.selectInventTypes.bind(this);
    this.onDeleteInventTypes = this.onDeleteInventTypes.bind(this);
    this.searchByText = this.searchByText.bind(this);
    this.triggerColumnChooser = this.triggerColumnChooser.bind(this);
    this.showDeleteModal = this.showDeleteModal.bind(this);
    this.showAddModal = this.showAddModal.bind(this);
    this.onRowClick = this.onRowClick.bind(this);

    this.dataGridRef = React.createRef();
  }

  selectInventTypes({ selectedRowsData }) {
    this.setState({ selectedInventTypes: selectedRowsData });
  }

  onDeleteInventTypes() {
    const { deleteResourceTypes } = this.props;
    const inventTypesIdList = this.state.selectedInventTypes.map(({ id }) => id);

    deleteResourceTypes(inventTypesIdList);
  }

  triggerColumnChooser() {
    this.dataGridRef.current.instance.showColumnChooser();
  }

  searchByText(e) {
    const text = e.target.value;
    this.dataGridRef.current.instance.searchByText(text);
  }

  showDeleteModal() {
    this.setState({
      deleteConfimationOpen: !this.state.deleteConfimationOpen
    });
  }

  showAddModal() {
    this.setState({ addInventTypeOpen: !this.state.addInventTypeOpen });
  }

  onRowClick(e) {
    const focusedInventType = e !== -1 ? e.data.id : e;
    const focusedRowIndex = e !== -1 ? e.rowIndex : e;
    this.setState({ focusedInventType, focusedRowIndex });

    if (focusedInventType !== -1){
      this.setState({ updateInventTypeOpen: true });
    }
    else{
      this.setState({ updateInventTypeOpen: false });
    }
  }

  render() {
    const {
      selectedInventTypes,
      deleteConfimationOpen,
      addInventTypeOpen,
      updateInventTypeOpen,
      focusedRowIndex,
      focusedInventType
    } = this.state;
    const {
      classes,
      restypes,
      getResourceTypes,
      //createInventType
    } = this.props;

    const { root, controls } = classes;

    return (
      <div className={root}>
        <Box>
          <DeleteConfirmationModal
            modalText="Удалить выбранные типы ресурсов?"
            open={deleteConfimationOpen}
            onConfirm={this.onDeleteInventTypes}
            handleClose={this.showDeleteModal}
          />
          <AddInventTypeModal
            open={addInventTypeOpen}
            handleClose={() => this.setState({ addInventTypeOpen: false })}
            //createInventType={createInventType}
            //getInventTypes={getResourceTypes}
            /*inventTypesList={inventTypesData.inventtypesList}
            isCreatingInventType={inventTypesData.isCreatingInventType}
            createdInventType={inventTypesData.createdInventType}*/
          />
          <UpdateInventTypeModal
            open={updateInventTypeOpen}
            handleClose={
              () => {this.setState({ updateInventTypeOpen: false });
              this.onRowClick(-1);}
            }
            resTypeId={focusedInventType}
          />
          <div className={controls}>
            <div>
              Оборудование/Инструменты/ПО
            </div>
            <div>
              <AddButton onClick={this.showAddModal}/>
              {selectedInventTypes.length > 0 &&
              <DeleteButton onClick={this.showDeleteModal}/>}
            </div>
          </div>
          <div>
            <DataGrid
              elementAttr={{
                id: "gridContainer"
              }}
              ref={this.dataGridRef}
              dataSource={restypes}
              onSelectionChanged={this.selectInventTypes}
              onRowClick={this.onRowClick}
              focusedRowIndex={focusedRowIndex}
              wordWrapEnabled={true}
              focusedRowEnabled
              errorRowEnabled={false}
              showBorders
            >
              <Selection
                mode="multiple"
                showCheckBoxesMode="onClick"
                showBorders={true}
                width={120}
              />
              {columns.map(column => (
                <Column key={column.dataField} {...column} />
              ))}
              <FilterRow visible={true} />
              <Scrolling mode="virtual" />
              <LoadPanel enabled />
            </DataGrid>
          </div>
        </Box>
      </div>
    );
  }
}

const mapStateToProps = state => ({
  isDeletingResTypes: state.nomenclature.isDeletingResTypes
});

const mapDispatchToProps = dispatch => ({
  deleteResourceTypes: (idList) => dispatch(deleteResourceTypes(idList))
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withStyles(styles)(InventoryTypeTable));
